import PortalIdParser from 'PortalIdParser';
import { CopilotChannelContext } from 'copilot-toolkit/channel/CopilotChannelContext';
import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { useCallback, useContext, useRef, useState } from 'react';
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
import { useHostAppName } from './hooks/useHostAppName';

// @ts-expect-error Not Typed
import { IFrame } from 'ui-addon-iframeable/host/IFrame';
import { jsx as _jsx } from "react/jsx-runtime";
const BREEZE_MODAL_RESIZE = 'BREEZE_MODAL_RESIZE';
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const COLLABORATION_SIDEBAR_WIDTH = 465;
const MODAL_OFFSET_MARGIN = 8;
const MODAL_OFFSET_WIDTH = COLLABORATION_SIDEBAR_WIDTH + MODAL_OFFSET_MARGIN;
const buildUrl = (hostAppName, instanceId) => {
  const env = enviro.deployed() ? 'app' : 'local';
  let url = `${getFullUrl(env)}/breeze-modal/${PortalIdParser.get()}?hostAppName=${hostAppName}&variant=uiiframe`;
  if (instanceId) {
    url += `&instanceId=${instanceId}`;
  }
  return url;
};
const BreezeModalHost = () => {
  const [modalType, setModalType] = useState(null);
  const [width, setWidth] = useState(DEFAULT_WIDTH);
  const [height, setHeight] = useState(DEFAULT_HEIGHT);
  const hostAppName = useHostAppName();
  const contextValue = useContext(CopilotChannelContext);
  const instanceId = contextValue === null || contextValue === void 0 ? void 0 : contextValue.instanceId;
  const iframeSrcRef = useRef();
  if (!iframeSrcRef.current) {
    iframeSrcRef.current = buildUrl(hostAppName, instanceId);
  }
  const isVisible = modalType !== null;
  const isLightbox = modalType === 'image-lightbox';
  const closeModal = useCallback(() => {
    setModalType(null);
  }, []);
  const showEmailSupport = useCallback(() => {
    setModalType('email-support');
  }, []);
  const showImageLightbox = useCallback(() => {
    setModalType('image-lightbox');
  }, []);
  const handleReady = useCallback(() => {}, []);
  const handleMessage = useCallback(message => {
    var _message$payload, _message$payload2;
    if (((_message$payload = message.payload) === null || _message$payload === void 0 ? void 0 : _message$payload.type) === MSG_TYPE_MODAL_DIALOG_CLOSE) {
      closeModal();
      return;
    }
    if (((_message$payload2 = message.payload) === null || _message$payload2 === void 0 ? void 0 : _message$payload2.type) === BREEZE_MODAL_RESIZE) {
      if (message.payload.width) {
        setWidth(message.payload.width);
      }
      if (message.payload.height) {
        setHeight(message.payload.height);
      }
    }
  }, [closeModal]);
  useSubscribeToCopilotChannel('OPEN_BREEZE_EMAIL_SUPPORT_MODAL', showEmailSupport);
  useSubscribeToCopilotChannel('OPEN_BREEZE_IMAGE_LIGHTBOX_MODAL', showImageLightbox);
  const containerStyle = isLightbox ? {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1112,
    display: isVisible ? 'block' : 'none',
    pointerEvents: 'auto'
  } : {
    position: 'fixed',
    bottom: MODAL_OFFSET_MARGIN,
    right: MODAL_OFFSET_WIDTH,
    zIndex: 1112,
    display: isVisible ? 'block' : 'none',
    pointerEvents: 'auto'
  };
  return /*#__PURE__*/_jsx("div", {
    style: containerStyle,
    children: /*#__PURE__*/_jsx(IFrame, {
      appName: "breeze-modal-ui",
      height: isVisible ? isLightbox ? '100%' : height : 0,
      initTimeout: 20000,
      name: "breeze-modal",
      onMessage: handleMessage,
      onReady: handleReady,
      scrolling: false,
      src: iframeSrcRef.current,
      width: isVisible ? isLightbox ? '100%' : width : 0
    })
  });
};
export default BreezeModalHost;